/**
 * Reads a server-sent event stream with JSON payloads (`data: {json}`,
 * blank line between events, `data: [DONE]` ends it) and yields each
 * payload. Malformed events are skipped. Use it in an app's
 * AssistantBackend.stream with the fetch Response of the chat endpoint.
 */
export async function* readSSE(res) {
    if (!res.body)
        return;
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    try {
        while (true) {
            const { done, value } = await reader.read();
            if (done)
                break;
            buffer += decoder.decode(value, { stream: true });
            const lines = buffer.split("\n");
            buffer = lines.pop() || "";
            for (const line of lines) {
                const trimmed = line.trim();
                if (!trimmed.startsWith("data: "))
                    continue;
                const data = trimmed.slice(6);
                if (data === "[DONE]")
                    return;
                try {
                    yield JSON.parse(data);
                }
                catch {
                    /* skip malformed event */
                }
            }
        }
    }
    finally {
        reader.releaseLock();
    }
}
